import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import CompanyHeritage from './components/CompanyHeritage';
import PortfolioShowcase from './components/PortfolioShowcase';
import TestimonialsSection from './components/TestimonialsSection';
import QuoteSection from './components/QuoteSection';
import WhatsAppWidget from './components/WhatsAppWidget';
import Footer from './components/Footer';

const Homepage = () => {
  useEffect(() => {
    // Set page title
    document.title = 'Kunjvihari Impex - Premium Fabric Manufacturer & Wholesaler | Surat, Gujarat';
    
    // Add meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute('content', 'Leading fabric manufacturer and wholesaler in Surat, Gujarat with 10+ years experience. Specializing in Polyester, Natural Crepe, Velvet Embroidery, Chinon, and Shimmer fabrics with competitive wholesale pricing and premium quality.');
    }

    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Header Navigation */}
      <Header />

      {/* Main Content */}
      <main className="pt-16">
        {/* Hero Section with Rotating Showcase */}
        <HeroSection />

        {/* Services Overview */}
        <ServicesOverview />

        {/* Company Heritage & Values */}
        <CompanyHeritage />

        {/* Portfolio Showcase */}
        <PortfolioShowcase />

        {/* Client Testimonials */}
        <TestimonialsSection />

        {/* Quote Request Section */}
        <QuoteSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* WhatsApp Chat Widget */}
      <WhatsAppWidget />
    </div>
  );
};

export default Homepage;